<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :max-width="350"
    left
    offset-x>
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" dark color="primary" v-if="$vuetify.breakpoint.mdAndUp" class="elevation-0">
        <b>{{usuario}}</b>
        <v-icon right dark>keyboard_arrow_down</v-icon>
      </v-btn>
      <v-btn v-on="on" text dark icon v-else>
        <v-icon>account_box</v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-list class="py-0">
        <v-list-item>
          <v-list-item-avatar color="accent" class="white--text headline">
            {{ usuario.substring(0,1).toUpperCase() }}
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title><span v-if="estruturaUsuario">{{estruturaUsuario}} - </span>{{usuario}}</v-list-item-title>
            <v-list-item-subtitle>{{mail}}</v-list-item-subtitle>
            <v-list-item-subtitle><span class='text--primary'>{{$tc('label.perfil', 1)}}: </span>{{perfil}}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-divider></v-divider>

      <v-list v-if="exibirControladores" class="py-0">
        <v-list-item
          v-for="(item, index) in controladores"
          :key="index">
          <v-list-item-title class="grey--text text--darken-1">{{ item.descricao }}</v-list-item-title>
        </v-list-item>
      </v-list>

      <v-divider v-if="exibirControladores"></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="logout">
          <v-icon dark>power_settings_new</v-icon>
          <span>{{$tc('label.logout', 2)}}</span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'UsuarioToolbar',
  props: {
    usuario: String,
    mail: String,
    estruturaUsuario: String,
    perfil: String,
  },
  data: () => ({
    menu: false,
    message: false,
    hints: true,
  }),
  computed: {
    ...mapGetters('controlador', [
      'getControladores',
      'getControladoreSelecionado',
    ]),
    controladores() {
      return this.getControladores || [];
    },
    temControladores() {
      return !!this.controladores.length;
    },
    exibirControladores() {
      // Issue 258: Está criando controlador com funcionario titular
      // quando o usuario não tem divisão
      // Após editar o funcionário com divisão, acabava ficando com dois controladores
      // Essa funcionalidade será revisada no estágio 3
      return this.temControladores
        && (this.controladores.length > 1
          || (this.controladores.length === 1 && !!this.controladores[0].idDivisaoTitular));
    },
  },
  methods: {
    selecionar(item) {
      this.menu = false;
      this.$emit('UsuarioToolBar_selecionar', item);
    },
    logout() {
      this.menu = false;
      const auth = this.$auth || window.auth;
      if (this.$router.currentRoute
          && this.$router.currentRoute.name !== 'dashboard-inicial') {
        this.$router.push({ name: 'inicio' });
      }
      window.sessionStorage.clear();
      auth.logout();
    },
  },
};
</script>

<style scoped>

</style>
